import { render, staticRenderFns } from "./BaseTemplate.vue?vue&type=template&id=215afce8&scoped=true&"
import script from "./BaseTemplate.vue?vue&type=script&lang=js&"
export * from "./BaseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215afce8",
  null
  
)

export default component.exports